module.exports = __webpack_public_path__ + "img/10.92d86c5f.png";